import Navbar from '../../navbar/Navbar'
import Footer from '../../footer/Footer';
import EceleftTab from './EceleftTab';



const EceIndustrySupportedLab = () => {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">
                            <EceleftTab />
                        </div>
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2 className='fs-3'>
                                    ECE Industry Supported Lab
                                </h2>

                                <div className='pt-2 submit'>
                                    <div className='eventsImages'>
                                        <div className='row mt-4'>

                                            <div className='col-md-6 col-lg-6 mb-3 '>
                                                <img height={"200"} src="https://admin.swec.ac.in/assetsswec/img/ece/Advanced-Communication_Spectrum-Analyzer_OFDM-TxRx.jpeg"
                                                    alt="Advanced Communication Lab" class="img-responsive rounded-1 center-block" loading="lazy" />
                                                <h6 className='pt-3'>
                                                    Advanced Communication: Spectrum Analyzer & OFDM Transmitter/Receiver
                                                </h6>
                                            </div>

                                            <div className='col-md-6 col-lg-6 mb-3 '>
                                                <img height={"200"} src="https://admin.swec.ac.in/assetsswec/img/ece/IOT_Raspberry-Pi_Arduino-UNO-1.jpeg"
                                                    alt="IoT Lab with Raspberry Pi and Arduino UNO" class="img-responsive rounded-1 center-block" loading="lazy" />
                                                <h6 className='pt-3'>
                                                    IoT Lab: Raspberry Pi & Arduino UNO
                                                </h6>
                                            </div>

                                            <div className='col-md-6 col-lg-6 mb-3 '>
                                                <img height={"200"} src="https://admin.swec.ac.in/assetsswec/img/ece/VLSI-ZYNQ-Board.jpeg"
                                                    alt="VLSI Zynq Board" class="img-responsive rounded-1 w-100 center-block" loading="lazy" />
                                                <h6 className='pt-3'>
                                                    VLSI Design Lab: ZYNQ Development Board
                                                </h6>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default EceIndustrySupportedLab;

